import React, { useEffect, useState } from "react";
import axiosClient from "../api/axiosClient";

const initialProfile = {
    username: "",
    email: "",
    name: "",
    // Add other profile fields here as needed
};

const Profile = () => {
    const [profile, setProfile] = useState(initialProfile);
    const [profileMsg, setProfileMsg] = useState("");
    const [profileErr, setProfileErr] = useState("");
    const [savingProfile, setSavingProfile] = useState(false);
    
    const [pwdForm, setPwdForm] = useState({ oldPassword: "", newPassword: "", confirmPassword: "" });
    const [pwdMsg, setPwdMsg] = useState("");
    const [pwdErr, setPwdErr] = useState("");
    const [changingPwd, setChangingPwd] = useState(false);
    
    useEffect(() => {
        fetchProfile();
    }, []);
    
    const fetchProfile = async () => {
        try {
            const res = await axiosClient.get("/profile");
            setProfile(res.data.data.user || initialProfile);
        } catch {
            // handle error as needed
        }
    };
    
    const handleProfileChange = (e) => {
        setProfile({ ...profile, [e.target.name]: e.target.value });
    };
    
    const handleProfileSubmit = async (e) => {
        e.preventDefault();
        setProfileMsg("");
        setProfileErr("");
        setSavingProfile(true);
        try {
            const res = await axiosClient.put("/profile", profile);
            setProfileMsg(res.data.message || "Profile updated.");
        } catch (err) {
            setProfileErr(err.response?.data?.message || "Failed to update profile.");
        } finally {
            setSavingProfile(false);
        }
    };
    
    const handlePwdChange = (e) => {
        setPwdForm({ ...pwdForm, [e.target.name]: e.target.value });
    };
    
    const handlePwdSubmit = async (e) => {
        e.preventDefault();
        setPwdMsg("");
        setPwdErr("");
        if (!pwdForm.oldPassword || !pwdForm.newPassword || !pwdForm.confirmPassword) {
            setPwdErr("Please fill in all password fields.");
            return;
        }
        if (pwdForm.newPassword !== pwdForm.confirmPassword) {
            setPwdErr("New password and confirm password do not match.");
            return;
        }
        setChangingPwd(true);
        try {
            const res = await axiosClient.post("/profile/change-password", {
                oldPassword: pwdForm.oldPassword,
                newPassword: pwdForm.newPassword,
                confirmPassword: pwdForm.confirmPassword,
            });
            setPwdMsg(res.data.message || "Password changed successfully.");
            setPwdForm({ oldPassword: "", newPassword: "", confirmPassword: "" });
        } catch (err) {
            setPwdErr(err.response?.data?.message || "Failed to change password.");
        } finally {
            setChangingPwd(false);
        }
    };
    
    return (
        <div className="container mt-4" style={{ maxWidth: 600 }}>
            <h2 className="mb-4">Profile</h2>
            
            <div className="card mb-4">
                <div className="card-body">
                    <h5 className="card-title">Edit Profile Info</h5>
                    {profileMsg && <div className="alert alert-success">{profileMsg}</div>}
                    {profileErr && <div className="alert alert-danger">{profileErr}</div>}
                    <form onSubmit={handleProfileSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Username</label>
                            <input
                                className="form-control"
                                name="username"
                                value={profile.username}
                                onChange={handleProfileChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Email</label>
                            <input
                                className="form-control"
                                name="email"
                                type="email"
                                value={profile.email}
                                onChange={handleProfileChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Name</label>
                            <input
                                className="form-control"
                                name="name"
                                value={profile.name}
                                onChange={handleProfileChange}
                            />
                        </div>
                        {/* Add more fields here as needed */}
                        <button className="btn btn-primary" type="submit" disabled={savingProfile}>
                            {savingProfile ? "Saving..." : "Save"}
                        </button>
                    </form>
                </div>
            </div>
            
            <div className="card mb-4">
                <div className="card-body">
                    <h5 className="card-title">Change Password</h5>
                    {pwdMsg && <div className="alert alert-success">{pwdMsg}</div>}
                    {pwdErr && <div className="alert alert-danger">{pwdErr}</div>}
                    <form onSubmit={handlePwdSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Old Password</label>
                            <input
                                className="form-control"
                                name="oldPassword"
                                type="password"
                                value={pwdForm.oldPassword}
                                onChange={handlePwdChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">New Password</label>
                            <input
                                className="form-control"
                                name="newPassword"
                                type="password"
                                value={pwdForm.newPassword}
                                onChange={handlePwdChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Confirm New Password</label>
                            <input
                                className="form-control"
                                name="confirmPassword"
                                type="password"
                                value={pwdForm.confirmPassword}
                                onChange={handlePwdChange}
                                required
                            />
                        </div>
                        <button className="btn btn-primary" type="submit" disabled={changingPwd}>
                            {changingPwd ? "Changing..." : "Change Password"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Profile;
